
import * as Models from "../.";
import {MarketAssumedValuesBase} from ".";
export class PilotPricingAssumedValues extends MarketAssumedValuesBase.MarketAssumedValuesBase {
  defaultContractSignDate?: Date;
  epcCap: number;
  termLength: number;
  developmentFeePercent: number;
  percentDegredation: number;
  srecFactor: number;
  srecCommissionPercent: number;
  srecPriceIntervals: Models.MarketAssumedValuesModel.SrecPriceInterval[];
  operationManagementCostPerKw: number;
  operationManagementEscalator: number;
  operationManagementFreeStartYears: number;
  insuranceRate: number;
  insuranceEscalator: number;
  assetManagementFeePerKw: number;
  igsCorporateTaxRate: number;
  investmentTaxCreditPercent: number;
  bonusDepreciationPercent: number;
  acceleratedDepreciationPoints: Models.MarketAssumedValuesModel.IAcceleratedDepreciationPoints[];
}
